"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f122 = void 0;
exports.f122 = {
    "zubazuba": [
        72
    ],
    "zofari": [
        91
    ],
    "zend": [
        112,
        113,
        114
    ],
    "za": [
        3106,
        132,
        133,
        134,
        1540,
        2224,
        2402,
        2406,
        2640,
        2673,
        3918,
        3924,
        4555,
        5427,
        5661,
        5662,
        5682,
        5695,
        5696,
        5940,
        6802,
        7127,
        7156,
        7613,
        7727,
        7728,
        8067,
        8068,
        8400,
        8452,
        8472,
        8473,
        8483,
        9172,
        9173
    ],
    "zaiwa": [
        486,
        487,
        9068
    ],
    "zi": [
        486,
        487,
        4787,
        3005,
        3006,
        3007,
        3008,
        3009,
        5656
    ],
    "zm": [
        515,
        727,
        728,
        1223,
        2225,
        3193,
        3911,
        4205,
        4267,
        4272,
        4467,
        4521,
        4528,
        4563,
        4758,
        4780,
        5186,
        5219,
        5511,
        5685,
        6716,
        6851,
        6870,
        7158,
        7645,
        7766,
        9157
    ],
    "zambia": [
        727,
        728,
        4780,
        5532,
        7645,
        515,
        1223,
        2225,
        3193,
        3911,
        4205,
        4267,
        4272,
        4467,
        4521,
        4528,
        4563,
        4758,
        5186,
        5219,
        5511,
        5685,
        6716,
        6851,
        6870,
        7158,
        7766,
        9157
    ],
    "zacapoaxtla": [
        608
    ],
    "zacapoaxtla náhuat": [
        608
    ],
    "zana": [
        633
    ],
    "záágé": [
        714,
        715
    ],
    "zamba": [
        980
    ],
    "zang": [
        997,
        999,
        1000,
        1001
    ],
    "zang wen": [
        997,
        1000,
        1001
    ],
    "zaomin": [
        1037
    ],
    "zabaan": [
        1077
    ],
    "zogben": [
        1188
    ],
    "zogbeya": [
        1188
    ],
    "zogbme": [
        1188
    ],
    "zugweya": [
        1188
    ],
    "zora": [
        1362
    ],
    "zhuoni": [
        1386
    ],
    "zanniat": [
        1432
    ],
    "zimbrisch": [
        1471
    ],
    "zenap": [
        1488
    ],
    "zona": [
        1528,
        1669,
        7752
    ],
    "znakový": [
        1633
    ],
    "zhongguo shouyu": [
        1641
    ],
    "zhongguo": [
        1641
    ],
    "znakovni": [
        1647,
        8906
    ],
    "zo pau": [
        1658,
        1659
    ],
    "zo": [
        1658,
        1659,
        1718,
        6050,
        9115
    ],
    "zome": [
        1658,
        1659,
        6075,
        8057,
        9115
    ],
    "zomi": [
        1658,
        1659,
        6075,
        8057
    ],
    "zacatepec": [
        1676,
        5255
    ],
    "zacatepec chatino": [
        1676
    ],
    "zenzontepec": [
        1716
    ],
    "zenzontepec chatino": [
        1716
    ],
    "zhong": [
        1717
    ],
    "zotung": [
        1718
    ],
    "zo mingphuin": [
        1718
    ],
    "zobya": [
        1718
    ],
    "zotung chin": [
        1718
    ],
    "zhatie": [
        1804,
        1805
    ],
    "zaghvana": [
        1819
    ],
    "zemba": [
        1836
    ],
    "ziki": [
        1847
    ],
    "zhitako": [
        1858
    ],
    "zitako": [
        1858
    ],
    "zarma": [
        1872,
        1873,
        1874
    ],
    "zarmaciine": [
        1872,
        1873,
        1874
    ],
    "zabarma": [
        1872,
        1873,
        1874
    ],
    "zarbarma": [
        1872,
        1873,
        1874
    ],
    "zarma sanni": [
        1872,
        1873,
        1874
    ],
    "zarmaci": [
        1872,
        1873,
        1874
    ],
    "zerma": [
        1872,
        1873,
        1874
    ],
    "zwn’jan": [
        1917
    ],
    "zw": [
        1948,
        2226,
        3516,
        3545,
        5207,
        5358,
        5580,
        6989,
        6990,
        9052
    ],
    "zimbabwe": [
        9052,
        5358,
        1948,
        2226,
        3516,
        3545,
        5207,
        5580,
        6989,
        6990
    ],
    "zuru": [
        1959
    ],
    "zaa": [
        2011
    ],
    "zongkhar": [
        2044
    ],
    "zealand": [
        5818,
        4790,
        2191
    ],
    "zulu": [
        9172,
        9173,
        2406
    ],
    "zaakosa": [
        2479,
        2480
    ],
    "zemay": [
        2479,
        2480
    ],
    "zoroastrian": [
        2564
    ],
    "zoroastrian dari": [
        2564
    ],
    "zulgo-gemzek": [
        2707
    ],
    "zoulgo": [
        2707
    ],
    "zulgo": [
        2707
    ],
    "zenatiyya": [
        2775
    ],
    "zeʼegete": [
        2804
    ],
    "zhuh": [
        2848
    ],
    "zime": [
        2923,
        4397,
        5605,
        9055
    ],
    "zime pala": [
        2923
    ],
    "zime of pala": [
        2923
    ],
    "zibito": [
        2938
    ],
    "zedong": [
        3266,
        5710
    ],
    "zarek": [
        3300
    ],
    "zazao": [
        3312
    ],
    "zero": [
        3345
    ],
    "zero mala": [
        3345
    ],
    "zerum": [
        3345
    ],
    "zina": [
        3362
    ],
    "zoulbou": [
        3366
    ],
    "zhongzhai": [
        3373
    ],
    "zhar": [
        3379
    ],
    "zumbun": [
        3390
    ],
    "zangram": [
        3400
    ],
    "zhang-zhung": [
        8714,
        3400
    ],
    "zrai": [
        3419,
        3420
    ],
    "zhiru": [
        3422
    ],
    "ziral": [
        3433
    ],
    "zazaki, northern": [
        3688
    ],
    "zazaki": [
        3688,
        9186,
        9187
    ],
    "zaza": [
        9186,
        9187,
        3688
    ],
    "zazaca": [
        3688,
        9186,
        9187
    ],
    "zazaja": [
        3688
    ],
    "zonê ma": [
        3688
    ],
    "zonê": [
        3688
    ],
    "zabana": [
        3706
    ],
    "zoono": [
        3766
    ],
    "zanichi korean": [
        3847,
        3848,
        3850
    ],
    "zanichi": [
        3847,
        3848,
        3850
    ],
    "zhu’oasi": [
        4006
    ],
    "zyrian": [
        4041,
        4042
    ],
    "zayein": [
        4110
    ],
    "zayein karen": [
        4110
    ],
    "zargon": [
        4189,
        4190,
        4191
    ],
    "zeneize": [
        4333
    ],
    "zīmju": [
        4496
    ],
    "zan": [
        9107,
        4568,
        4569,
        4570
    ],
    "zao": [
        5048
    ],
    "záá múndàŋ": [
        5126
    ],
    "záá": [
        5126
    ],
    "zaachila": [
        9170,
        5223
    ],
    "zacatepec mixtec": [
        5255
    ],
    "zeliang": [
        5329,
        5501,
        5817
    ],
    "zangnte": [
        5443
    ],
    "zacatlán-ahuacatlán-tepetzintla": [
        5453
    ],
    "zacatlán": [
        5453
    ],
    "zacatlán-ahuacatlán-tepetzintla nahuatl": [
        5453
    ],
    "zani": [
        5493
    ],
    "zany": [
        5493
    ],
    "zimu": [
        5508
    ],
    "zongolica": [
        5556
    ],
    "zeme": [
        5817,
        5565
    ],
    "zwanga": [
        5725
    ],
    "zakara": [
        5816
    ],
    "zeliangrong": [
        5817
    ],
    "zeme naga": [
        5817
    ],
    "zemi": [
        5817
    ],
    "zhongjia": [
        6062,
        6063
    ],
    "zoukam": [
        6075,
        9115
    ],
    "zubann": [
        6177
    ],
    "zei": [
        6309
    ],
    "zaban eshareh irani": [
        6309
    ],
    "zaban": [
        6309
    ],
    "zo’é": [
        6345
    ],
    "zo'é": [
        6345
    ],
    "zhaba": [
        9043,
        6428
    ],
    "zigeuner": [
        6556
    ],
    "zaar": [
        6686
    ],
    "zambal": [
        6702,
        6971
    ],
    "zurubu": [
        6750
    ],
    "zhemaitish": [
        6822
    ],
    "ziche": [
        6873
    ],
    "zira": [
        6873
    ],
    "zire": [
        6873
    ],
    "zenati": [
        6888
    ],
    "zezuru": [
        6989,
        6990
    ],
    "zeona": [
        7004
    ],
    "zhgabe": [
        7068,
        7070,
        7071
    ],
    "zaïre swahili": [
        7230,
        7231
    ],
    "zaïre": [
        7230,
        7231
    ],
    "zuruahã": [
        7251
    ],
    "zimirra": [
        7278
    ],
    "zabwa": [
        7315
    ],
    "zittiro": [
        7497
    ],
    "zıvon": [
        7584,
        7585,
        7586
    ],
    "zambezi": [
        7645
    ],
    "zimshian": [
        7737
    ],
    "ziran": [
        7745
    ],
    "zinacantan": [
        7891
    ],
    "zhestiv": [
        7937
    ],
    "zhestova": [
        7937
    ],
    "zhestivoyu": [
        7937
    ],
    "zuba": [
        8101
    ],
    "zuba koro": [
        8101
    ],
    "zhonjigali": [
        8182
    ],
    "zik": [
        8183,
        8184,
        8185
    ],
    "zorop": [
        8216
    ],
    "zama": [
        8684
    ],
    "zemgalian": [
        8715
    ],
    "zapotec": [
        8969,
        8970,
        8971,
        8972,
        8973,
        8974,
        8982,
        8983,
        8984,
        8985,
        8986,
        8987,
        8988,
        8990,
        8991,
        8992,
        9003,
        9116,
        9120,
        9121,
        9122,
        9123,
        9124,
        9125,
        9126,
        9127,
        9128,
        9129,
        9130,
        9131,
        9132,
        9133,
        9134,
        9135,
        9136,
        9137,
        9138,
        9139,
        9140,
        9141,
        9142,
        9143,
        9144,
        9145,
        9158,
        9160,
        9161,
        9162,
        9163,
        9164,
        9165,
        9166,
        9167,
        9168,
        9169,
        9170,
        9171,
        8716
    ],
    "zavég": [
        8724,
        8725
    ],
    "zgyamigyai": [
        8724,
        8725
    ],
    "zǵamiǵai": [
        8724,
        8725
    ],
    "zhuang": [
        8966,
        8967,
        8968,
        9004,
        9009,
        9013,
        9015,
        9016,
        9044,
        9045,
        9047,
        9048,
        9075,
        9076,
        9079,
        9080,
        9146,
        9147,
        9181,
        9182,
        9183,
        9184,
        9188,
        8790,
        8834,
        8964
    ],
    "zokhuo": [
        8965,
        8819
    ],
    "zokhuo na": [
        8819
    ],
    "zemapho": [
        8884
    ],
    "zoyaha": [
        8921
    ],
    "zekhe": [
        8965
    ],
    "zuoke": [
        8965
    ],
    "zhuang, yongbei": [
        8966,
        8967
    ],
    "zapotec, sierra de juárez": [
        8969
    ],
    "zapoteco": [
        8970,
        8971,
        8972,
        8973,
        8974,
        8982,
        8983,
        8984,
        8985,
        8986,
        8987,
        8988,
        8990,
        8992,
        9003,
        9116,
        9120,
        9121,
        9122,
        9123,
        9124,
        9125,
        9126,
        9127,
        9128,
        9129,
        9130,
        9131,
        9133,
        9134,
        9135,
        9136,
        9138,
        9139,
        9140,
        9141,
        9142,
        9143,
        9144,
        9145,
        9158,
        9160,
        9161,
        9162,
        9164,
        9165,
        9166,
        9167,
        9168,
        9169,
        9171,
        8969,
        9132
    ],
    "zapoteco de atepec": [
        8969
    ],
    "zapotec, western tlacolula valley": [
        8970
    ],
    "zapoteco de san juan": [
        8970
    ],
    "zapoteco de tlacolula occidental": [
        8970
    ],
    "zapotec, ocotlán": [
        8971
    ],
    "zapoteco del poniente de ocotlán": [
        8971
    ],
    "zapotec, cajonos": [
        8972
    ],
    "zapoteco de san pedro cajonos": [
        8972
    ],
    "zapotec, yareni": [
        8973
    ],
    "zapoteco de santa ana yareni": [
        8973
    ],
    "zapoteco de teococuilco de marcos pérez": [
        8973
    ],
    "zapotec, ayoquesco": [
        8974
    ],
    "zapoteco de santa maría ayoquesco": [
        8974
    ],
    "zaghawa": [
        8975,
        8976,
        8977
    ],
    "zagaoua": [
        8975,
        8976,
        8977
    ],
    "zagawa": [
        8975,
        8976,
        8977
    ],
    "zauge": [
        8975,
        8976,
        8977
    ],
    "zeggaoua": [
        8975,
        8976,
        8977
    ],
    "zeghawa": [
        8975,
        8976,
        8977
    ],
    "zorhaua": [
        8975,
        8976,
        8977
    ],
    "zangwal": [
        8978
    ],
    "zwangal": [
        8978
    ],
    "zaramo": [
        8979
    ],
    "zalamo": [
        8979
    ],
    "zaramu": [
        8979
    ],
    "zanaki": [
        8980
    ],
    "zauzou": [
        8981
    ],
    "zapotec, miahuatlán": [
        8982
    ],
    "zapoteco de miahuatlán": [
        8982
    ],
    "zapotec, ozolotepec": [
        8983
    ],
    "zha": [
        8983,
        9043,
        9068
    ],
    "zapoteco de ozolotepec": [
        8983
    ],
    "zapotec, isthmus": [
        8984
    ],
    "zapoteco istmeño": [
        8984
    ],
    "zapoteco del istmo": [
        8984
    ],
    "zapotec, aloápam": [
        8985
    ],
    "zapoteco de aloápam": [
        8985
    ],
    "zapotec, rincón": [
        8986
    ],
    "zapoteco de yagallo": [
        8986
    ],
    "zapoteco del rincón": [
        8986
    ],
    "zapotec, santo domingo albarradas": [
        8987
    ],
    "zapoteco de santo domingo albarradas": [
        8987
    ],
    "zapotec, tabaa": [
        8988
    ],
    "zapoteco de tabaa": [
        8988
    ],
    "zangskari": [
        8989
    ],
    "zanskari": [
        8989
    ],
    "zaskari": [
        8989
    ],
    "zapotec, yatzachi": [
        8990
    ],
    "zapoteco de yatzachi": [
        8990
    ],
    "zapotec, mitla": [
        8991
    ],
    "zapotec, xadani": [
        8992
    ],
    "zapoteco de santa maría xadani": [
        8992
    ],
    "zayse": [
        8993,
        8994
    ],
    "zaysite": [
        8993
    ],
    "zari": [
        8995
    ],
    "zariwa": [
        8995
    ],
    "zaranda": [
        9001
    ],
    "zarandawa": [
        9001
    ],
    "zapotec, coatecas altas": [
        9003
    ],
    "zapoteco de san juan coatecas altas": [
        9003
    ],
    "zhuang, central hongshuihe": [
        9004
    ],
    "zeeuws": [
        9007
    ],
    "zeaws": [
        9007
    ],
    "zeelandic": [
        9007
    ],
    "zeêuws": [
        9007
    ],
    "zenag": [
        9008
    ],
    "zenang": [
        9008
    ],
    "zhuang, eastern hongshuihe": [
        9009
    ],
    "zenaga": [
        9010,
        9011
    ],
    "zenaga berber": [
        9010,
        9011
    ],
    "zhuang, guibei": [
        9013
    ],
    "zhuang, minz": [
        9015
    ],
    "zong zhuang": [
        9015
    ],
    "zong": [
        9015
    ],
    "zhuang, guibian": [
        9016
    ],
    "zhongguohua": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "zaba": [
        9043
    ],
    "zhuang, dai": [
        9044,
        9045
    ],
    "zhuangyu nanbu fangyan wen-ma tuyu": [
        9044,
        9045
    ],
    "zhuangyu": [
        9044,
        9045,
        9047,
        9048,
        9181,
        9184,
        9188
    ],
    "zhuangyu nanbu fangyan dejing tuyu": [
        9044,
        9045,
        9181
    ],
    "zhire": [
        9046
    ],
    "zhuang, nong": [
        9047,
        9048
    ],
    "zhuangyu nanbu fanyan yan-guang tuyu": [
        9047,
        9048
    ],
    "zhoa": [
        9049
    ],
    "zia": [
        9051
    ],
    "ziya": [
        9051
    ],
    "zimbabwe sign language": [
        9052
    ],
    "zimsign": [
        9052
    ],
    "zimakani": [
        9053
    ],
    "zialo": [
        9054
    ],
    "zialu": [
        9054
    ],
    "ziolo": [
        9054
    ],
    "ziyolo": [
        9054
    ],
    "zime of kélo": [
        9055
    ],
    "zinza": [
        9056
    ],
    "zinja": [
        9056
    ],
    "zigula": [
        9057
    ],
    "zeguha": [
        9057
    ],
    "zegura": [
        9057
    ],
    "zigoua": [
        9057
    ],
    "zigua": [
        9057
    ],
    "zigwa": [
        9057
    ],
    "zizilivakan": [
        9058
    ],
    "zhilvu": [
        9058
    ],
    "ziliva": [
        9058
    ],
    "ziziliveken": [
        9058
    ],
    "zakhring": [
        9068
    ],
    "zhahua": [
        9068
    ],
    "zula": [
        9074
    ],
    "zura": [
        9074
    ],
    "zhuang, liujiang": [
        9075,
        9076
    ],
    "zhuang, lianshan": [
        9079
    ],
    "zhuang, liuqian": [
        9080
    ],
    "zimba": [
        9082
    ],
    "zan gula": [
        9107
    ],
    "zande": [
        9108,
        9109
    ],
    "zande (individual language)": [
        9108,
        9109
    ],
    "zandi": [
        9108,
        9109
    ],
    "zoque, copainalá": [
        9113
    ],
    "zoque": [
        9113,
        9114,
        9117,
        9118,
        9119
    ],
    "zoque de copainalá": [
        9113
    ],
    "zoque, chimalapa": [
        9114
    ],
    "zou": [
        9115
    ],
    "zohâm": [
        9115
    ],
    "zokam": [
        9115
    ],
    "zou chin": [
        9115
    ],
    "zapotec, asunción mixtepec": [
        9116
    ],
    "zimatlan": [
        9116,
        9135
    ],
    "zapoteco de asunción mixtepec": [
        9116
    ],
    "zoque, tabasco": [
        9117
    ],
    "zoque de ayapanec": [
        9117
    ],
    "zoque de tabasco": [
        9117
    ],
    "zoque, rayón": [
        9118
    ],
    "zoque de rayón": [
        9118
    ],
    "zoque, francisco león": [
        9119
    ],
    "zoque de francisco león": [
        9119
    ],
    "zapotec, lachiguiri": [
        9120
    ],
    "zapoteco de santiago lachiguiri": [
        9120
    ],
    "zapotec, yautepec": [
        9121
    ],
    "zapoteco de san bartolo yautepec": [
        9121
    ],
    "zapotec, choapan": [
        9122
    ],
    "zapoteco de choapan": [
        9122
    ],
    "zapoteco de san juan comaltepec": [
        9122
    ],
    "zapotec, southeastern ixtlán": [
        9123
    ],
    "zapoteco del sureste de ixtlán": [
        9123
    ],
    "zapotec, petapa": [
        9124
    ],
    "zapoteco de santa maría petapa": [
        9124
    ],
    "zapotec, san pedro quiatoni": [
        9125
    ],
    "zapoteco de san pedro quiatoni": [
        9125
    ],
    "zah": [
        9125
    ],
    "zapotec, guevea de humboldt": [
        9126
    ],
    "zapoteco de guevea de humboldt": [
        9126
    ],
    "zapotec, totomachapan": [
        9127
    ],
    "zimatlán": [
        9127,
        9133
    ],
    "zapoteco de san pedro totomachapan": [
        9127
    ],
    "zapotec, santa maría quiegolani": [
        9128
    ],
    "zapoteco de santa maría quiegolani": [
        9128
    ],
    "zapotec, quiavicuzas": [
        9129
    ],
    "zapoteco de quiavicuzas": [
        9129
    ],
    "zapoteco de san juan lachixila": [
        9129
    ],
    "zapotec, tlacolulita": [
        9130
    ],
    "zapoteco de asunción tlacolulita": [
        9130
    ],
    "zapotec, lachixío": [
        9131
    ],
    "zapoteco de lachixío": [
        9131
    ],
    "zapotec, mixtepec": [
        9132
    ],
    "zapoteco de san juan mixtepec": [
        9132
    ],
    "zapotec, santa inés yatzechi": [
        9133
    ],
    "zapoteco de santa inés yatzechi": [
        9133
    ],
    "zapoteco de zegache": [
        9133
    ],
    "zegache": [
        9133
    ],
    "zapotec, amatlán": [
        9134
    ],
    "zapoteco de san cristóbal amatlán": [
        9134
    ],
    "zapoteco del noreste de miahuatlán": [
        9134
    ],
    "zapotec, el alto": [
        9135
    ],
    "zapoteco de san pedro el alto": [
        9135
    ],
    "zapotec, zoogocho": [
        9136
    ],
    "zoogocho": [
        9136
    ],
    "zapoteco de san bartolomé zoogocho": [
        9136
    ],
    "zoogocho zapotec": [
        9136
    ],
    "zapotec, santiago xanica": [
        9137
    ],
    "zapotec, coatlán": [
        9138
    ],
    "zapoteco de santa maría coatlán": [
        9138
    ],
    "zapotec, san vicente coatlán": [
        9139
    ],
    "zapoteco de san vicente coatlán": [
        9139
    ],
    "zapotec, yalálag": [
        9140
    ],
    "zapoteco de yalálag": [
        9140
    ],
    "zapotec, chichicapan": [
        9141
    ],
    "zapoteco de san baltazar chichicapan": [
        9141
    ],
    "zapotec, zaniza": [
        9142
    ],
    "zaniza": [
        9142
    ],
    "zaniza zapotec": [
        9142
    ],
    "zapoteco de santa maría zaniza": [
        9142
    ],
    "zapotec, san baltazar loxicha": [
        9143
    ],
    "zapoteco de san baltázar loxicha": [
        9143
    ],
    "zapotec, mazaltepec": [
        9144
    ],
    "zapoteco de santo tomás mazaltepec": [
        9144
    ],
    "zapotec, texmelucan": [
        9145
    ],
    "zapoteco de san lorenzo texmelucan": [
        9145
    ],
    "zhuang, qiubei": [
        9146,
        9147
    ],
    "zerenkel": [
        9151
    ],
    "zirenkel": [
        9151
    ],
    "záparo": [
        9152
    ],
    "zaparo": [
        9152
    ],
    "zápara": [
        9152
    ],
    "zarphatic": [
        9153
    ],
    "zambian sign language": [
        9157
    ],
    "zambian": [
        9157
    ],
    "zamsl": [
        9157
    ],
    "zapotec, southern rincon": [
        9158
    ],
    "zapoteco de rincón sur": [
        9158
    ],
    "zapotec, elotepec": [
        9160
    ],
    "zapoteco de san juan elotepec": [
        9160
    ],
    "zapotec, xanaguía": [
        9161
    ],
    "zë": [
        9161
    ],
    "zapoteco de santa catarina xanaguía": [
        9161
    ],
    "zapotec, lapaguía-guivini": [
        9162
    ],
    "zapoteco de lapaguía-guivini": [
        9162
    ],
    "zapoteco de santiago lapaguía": [
        9162
    ],
    "zapotec, san agustín mixtepec": [
        9163
    ],
    "zapotec, santa catarina albarradas": [
        9164
    ],
    "zapoteco de santa catarina albarradas": [
        9164
    ],
    "zapotec, loxicha": [
        9165
    ],
    "zapoteco de loxicha": [
        9165
    ],
    "zapotec, quioquitani-quierí": [
        9166
    ],
    "zapoteco de quioquitani y quierí": [
        9166
    ],
    "zapotec, tilquiapan": [
        9167
    ],
    "zapoteco de san miguel tilquiapan": [
        9167
    ],
    "zapotec, tejalapan": [
        9168
    ],
    "zapoteco de san felipe tejalapan": [
        9168
    ],
    "zapoteco de tejalápam": [
        9168
    ],
    "zapotec, güilá": [
        9169
    ],
    "zapoteco de san dionisio ocotepec": [
        9169
    ],
    "zapoteco de san pablo güilá": [
        9169
    ],
    "zapotec, zaachila": [
        9170
    ],
    "zaachila zapotec": [
        9170
    ],
    "zapotec, yatee": [
        9171
    ],
    "zapoteco de yatee": [
        9171
    ],
    "zapoteco serrano del sureste": [
        9171
    ],
    "zunda": [
        9172,
        9173
    ],
    "zeem": [
        9174
    ],
    "zaka": [
        9175
    ],
    "zuni": [
        9177
    ],
    "zuñi": [
        9177
    ],
    "zumaya": [
        9178
    ],
    "zay": [
        9179
    ],
    "zhuang, yang": [
        9181
    ],
    "zhuang, youjiang": [
        9182,
        9183
    ],
    "zhuang, yongnan": [
        9184
    ],
    "zhuangyu nanbu fangyan yongnan tuyu": [
        9184
    ],
    "zyphe": [
        9185
    ],
    "zo-pe": [
        9185
    ],
    "zophei": [
        9185
    ],
    "zoptei": [
        9185
    ],
    "zyphe chin": [
        9185
    ],
    "zazaki, southern": [
        9186,
        9187
    ],
    "zazakî": [
        9186,
        9187
    ],
    "zhuang, zuojiang": [
        9188
    ],
    "zuojiang": [
        9188
    ],
    "zhuangyu nanbu fangyan zuojiang tuyu": [
        9188
    ],
    "zuojiang zhuang": [
        9188
    ]
};
